import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onRouteUpdate = () => {
    if (typeof document !== "undefined") {
        const elements = document.querySelectorAll(".fadeInUp");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("on");
                    }
                });
            },
            { threshold: 0.1 }
        );

        elements.forEach((el) => observer.observe(el));

        // 動画は右クリック・ドラッグに加えて、再生メニューの保存・ピクチャーインピクチャーも出さない（管理画面・コードのどちらで入れた動画にも効く）
        document.querySelectorAll("video").forEach((video) => {
            video.setAttribute("controlslist", "nodownload noremoteplayback");
            video.disablePictureInPicture = true;
        });

        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }
};

export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js");

    const blockMedia = (e) => {
      if (e.target instanceof Element && e.target.closest("img, video")) {
        e.preventDefault();
      }
    };
    document.addEventListener("contextmenu", blockMedia);
    document.addEventListener("dragstart", blockMedia);
  }
};
